import { Extension } from '@tiptap/core';
import { NodeSelection, Plugin, PluginKey, type Selection } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export const quotePageSelectionKey = new PluginKey<string | null>('quotePageSelection');

/** A page owns its native content, nested tables and selected objects. */
export function quotePageIdAtSelection(selection: Selection): string | null {
  if (selection instanceof NodeSelection && selection.$from.depth === 0) {
    return selection.node.attrs.id ?? null;
  }
  return selection.$anchor.depth > 0 ? selection.$anchor.node(1).attrs.id ?? null : null;
}

export const QuotePageSelection = Extension.create({
  name: 'quotePageSelection',
  addProseMirrorPlugins() {
    const editor = this.editor;
    return [new Plugin<string | null>({
      key: quotePageSelectionKey,
      state: {
        init: () => null,
        apply: (tr, pageId) => {
          const selected = tr.getMeta(quotePageSelectionKey);
          if (selected !== undefined) return selected;
          if (tr.selectionSet || tr.docChanged) {
            return editor.view.dom.dataset.workspaceSelection !== 'active'
              ? null : quotePageIdAtSelection(tr.selection);
          }
          return pageId;
        },
      },
      props: {
        decorations: (state) => {
          const pageId = quotePageSelectionKey.getState(state);
          if (!pageId || !editor.isEditable) return DecorationSet.empty;
          const decorations: Decoration[] = [];
          state.doc.forEach((node, pos) => {
            if (node.attrs.id === pageId) {
              decorations.push(Decoration.node(pos, pos + node.nodeSize, {
                'data-quote-page-selected': 'true',
              }));
            }
          });
          return DecorationSet.create(state.doc, decorations);
        },
      },
    })];
  },
});
